const generateFetchSimilarContentQueryParams = (
  contentId: string,
  country: string,
  translation: string,
  languages: string,
  isPersonalized: boolean
) => {
  const queryParams = {
    id: contentId,
    filter: {
      country,
      translation,
      version: '1',
      languages,
      isPersonalized
    },
    collectionFilter: {
      page: 1,
      limit: 2,
      itemLimit: 20,
      country,
      translation,
      languages
    }
  };
  return queryParams;
};

export default generateFetchSimilarContentQueryParams;
